<ion-list class="list">
  @for (option of options; track option) {
    <ion-item lines="none" [button]="true" class="compact-item" (click)="closePopover(option.action)" [style]="textSize ? {'font-size': textSize} : ''">
      <ion-icon [color]="$safeNavigationMigration(option?.color)" [name]="option.icon"></ion-icon>
      <ion-label>&nbsp;&nbsp;{{option.text | translate}}</ion-label>
    </ion-item>
  }
</ion-list>
